<div class="formHintText" @demoAnimation>
  <!-- {{ "page.login.form.passwordRecovery.info" | translate }} -->
 <div class="FgtPassTitle">
   <h3>{{ "We’re here to help you recover your account." | translate }}</h3>
   <p>{{ "Please provide the information below to verify your identity:" | translate }}</p>
 </div> 
</div>
<form [formGroup]="passwordRecoveryForm" @demoAnimation>
  <!-- User ID Input Field -->
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.passwordRecovery.usernameField.label" | translate }}</mat-label>
    <input
      matInput
      noWhiteSpace="WIPE"
      id="txtForgotUsername"
      type="text"
      name="userID"
      [maxLength]="10"
      (focus)="disableAlternativeField('ClientId', 'EmailId')"
      (blur)="enableAllFields()"
      formControlName="ClientId"
    />
    <mat-error *ngIf="passwordRecoveryForm.get('ClientId')?.hasError('required')">
      {{ "page.login.form.passwordRecovery.requiredMutuallyExclusiveFieldMessage" | translate }}
    </mat-error>
    <mat-error *ngIf="passwordRecoveryForm.get('ClientId')?.hasError('invalidLength')">
      {{ "page.login.form.passwordRecovery.usernameField.invalidLengthMessage" | translate }}
    </mat-error>
  </mat-form-field>

  <div class="NotRobot_Captcha_Main">
  <!-- "I'm not a robot" Checkbox - Always visible -->
  <div class="NotRobot_Captcha">
    <mat-checkbox 
      formControlName="NotRobotCheckbox"
      [checked]="isNotRobotChecked"
      (change)="onNotRobotCheckboxChange($event.checked)"
      color="primary">
      I'm not a robot
    </mat-checkbox>
  </div>

  <!-- CAPTCHA Section - Only visible when checkbox is checked -->
  <div *ngIf="showCaptcha" class="NotRobot_Captcha_Wrap" @demoAnimation>
    <p class="TitleText">Please complete the CAPTCHA below: <span class="ImpField">*</span></p>
     <mat-form-field class="w-full" appearance="fill">
      <input 
        matInput 
        formControlName="Captcha" 
        name="captchaInput" 
        maxlength="6"
        autocomplete="off" placeholder="Enter CAPTCHA" />
      <div class="captcha-box" matSuffix>
       <div class="captcha-canvas"> <canvas #captchaCanvas width="160" height="40"></canvas> </div>
        <div class="captcha-controls">
          <button mat-icon-button type="button" (click)="generateCaptcha()" title="Refresh CAPTCHA">
            <mat-icon>refresh</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="playAudio()" title="Audio CAPTCHA">
            <mat-icon>volume_up</mat-icon>
          </button>
        </div>
      </div>
      <mat-error *ngIf="passwordRecoveryForm.get('Captcha')?.hasError('required')">
        {{ "CAPTCHA is required to continue." | translate }}
      </mat-error>
      <mat-error *ngIf="passwordRecoveryForm.get('Captcha')?.hasError('captchaMismatch')">
        {{ "page.login.form.passwordRecovery.captcha" | translate }}
      </mat-error>
    </mat-form-field>
  </div>
  </div>
  
  <!-- Submit Button - Disabled until all conditions are met -->
  <div class="BtnWrapper">
    <button type="button"
      id="btlForgotPwd"
      kendoButton
      color="primary"
      name="recover-password-button"
      [disabled]="!formIsValid"
      (click)="verify()"
      title=""
    >
      {{ "page.login.form.passwordRecovery.recoverButton" | translate }}
    </button>
  </div>
</form>
